import React from "react";
import { Plus } from "react-bootstrap-icons";
import Modal from "./Modal";
import ProjectForm from "./ProjectForm";
import { useState } from "react";
import firebase from "../firebase";

export default function AddNewProject() {
  // STATE
  const [showModal, setShowModal] = useState(false);
  const [projectName, setProjectName] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    if (projectName) {
      const projectsRef = firebase.firestore().collection("projects");
      projectsRef
        .where("name", "==", projectName)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.empty) {
            projectsRef.add({
              name: projectName,
            });
          } else {
            alert("project already exists");
          }
        });
      setShowModal(false);
      setProjectName("");
    }
  }

  return (
    <div className="AddNewProject">
      <div className="add-button">
        <span onClick={() => setShowModal(true)}>
          <Plus size="20" />
        </span>
      </div>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <ProjectForm
          handleSubmit={handleSubmit}
          heading="new project"
          value={projectName}
          setValue={setProjectName}
          setShowModal={setShowModal}
          confirmButtonText="+ add project"
        />
      </Modal>
    </div>
  );
}
